/**
 * UM My Queries tab entry point.
 *
 * TEMP: reuses the UM Queries list endpoint/UI.
 * Replace this implementation when UM My Queries has its own API/UI.
 */
import UmQueryTable from "../../Tables/UmQueryTable";

const UmMyQueries = UmQueryTable;

export default UmMyQueries;
